import { useRef, useState, useEffect } from "react";
import { Controller } from "react-hook-form";
import { EditAnswerButton } from "./EditButton";

export const AnswerInput = ({
  name,
  control,
  label,
  error,
  defaultValue = "",
  rules = {},
  onValueChange,
}) => {
  const inputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field: { value, onChange, onBlur }, fieldState }) => {
        const internalError = fieldState.error || error;

        // Auto-resize function
        const resizeTextarea = (textarea) => {
          if (textarea) {
            textarea.style.height = "auto";
            const scrollHeight = textarea.scrollHeight;
            const maxHeight = 120; // 4 lines max (24px line-height * 4 + padding)
            textarea.style.height = `${Math.min(scrollHeight, maxHeight)}px`;
          }
        };

        const handleFocus = () => {
          setIsFocused(true);
        };

        const handleBlur = (e) => {
          setIsFocused(false);
          onBlur();
        };

        const handleEditClick = () => {
          if (inputRef.current) {
            inputRef.current.focus();
            setIsFocused(true);
          }
        };

        const handleChange = (e) => {
          const newValue = e.target.value;
          onChange(newValue);
          // Update parent state directly
          if (onValueChange) {
            onValueChange(newValue);
          }
          // Auto-resize on change
          const textarea = e.target;
          if (textarea) {
            textarea.style.height = "auto";
            const scrollHeight = textarea.scrollHeight;
            const maxHeight = 120;
            textarea.style.height = `${Math.min(scrollHeight, maxHeight)}px`;
          }
        };

        return (
          <div className="d-flex flex-column w-full">
            <div
              className="d-flex flex-column relative w-full rounded-[24px]"
              // style={{ background: "#1B2C3A" }}
            >
              {label && (
                <label
                  style={{
                    color: "#C8CED3",
                    fontSize: 16,
                    fontWeight: 500,
                    marginBottom: "24px",
                    // lineHeight: "21px",
                  }}
                >
                  {label}
                </label>
              )}
              <div className="col-md-12">
                <div className="textfield-1" style={{ position: "relative" }}>
                  <textarea
                    ref={(el) => {
                      inputRef.current = el;
                      if (el) {
                        // Resize on mount and when ref is set
                        setTimeout(() => {
                          if (el) {
                            el.style.height = "auto";
                            const scrollHeight = el.scrollHeight;
                            const maxHeight = 120;
                            el.style.height = `${Math.min(
                              scrollHeight,
                              maxHeight,
                            )}px`;
                          }
                        }, 0);
                      }
                    }}
                    className={`text-body-b2 no-scrollbar ${
                      !isFocused ? "answer-input-no-border" : ""
                    }`}
                    placeholder=""
                    value={value ?? ""}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    rows={1}
                    style={{
                      paddingRight: "50px",
                      transition: "border 0.2s ease",
                      backgroundColor: "#1B2C3A",
                      borderRadius: "24px",
                      padding: "12px 16px",
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "24px",
                      color: "#C8CED3",
                      minHeight: "48px",
                      maxHeight: "120px", // 4 lines * 24px line-height + padding
                      resize: "none",
                      overflowY: "auto",
                      overflowX: "hidden",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                      whiteSpace: "pre-wrap",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      right: "16px",
                      top: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <EditAnswerButton
                      onPress={handleEditClick}
                      disabled={false}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex flex-row justify-content-between align-items-center">
              {internalError && (
                <div
                  className="text-danger"
                  style={{ fontSize: 12, width: "80%" }}
                >
                  {internalError.message}
                </div>
              )}
            </div>

            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  color: "#8798A7",
                  marginTop: "12px",
                }}
              >
                Character{(value?.length ?? 0) > 1 ? "s" : ""}:{" "}
                {value?.length ?? 0}
              </div>
            </div>
          </div>
        );
      }}
    />
  );
};
